@if (workarea) {
    <div (mousedown)="outsideClick($event)" class="container-fluid h-100">
        <div class="row">
            <div class="scroll-container">
                <div class="details-container">
                    <div class="detail-title">
                        <a routerLink="/{{ Routenames.customers }}/{{ workarea.customer_id }}">
                            <div class="icon"></div>
                            <div class="text">
                                <b>{{ workarea.number }}</b> Werkgebied
                            </div>
                        </a>
                        <div class="toolbar">
                            <div (click)="editDocumentDetails()" class="text curpoint">
                                &nbsp;{{ workarea.street }} - {{ workarea.status?.name }}
                                <i class="fas fa-pencil-alt"></i>
                            </div>
                        </div>
                        <div class="logo-small" routerLink="/"></div>
                    </div>
                    <div class="detail-title">
                        <div>
                            <div (click)="editDocumentDetails()" class="text curpoint">
                                &nbsp;{{ workarea.street }} - {{ workarea.status?.name }}
                                <i class="fas fa-pencil-alt"></i>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-24 col-md-18">
                            @if (!loaded && !workarea.id) {
                                <app-processbar></app-processbar>
                            }
                        </div>
                    </div>
                    <div class="folder-view">
                        <div class="file-menu"></div>
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li>
                                    <button (click)="up()" [disabled]="!parentItem" color="primary" mat-icon-button>
                                        <i class="fas fa-level-up-alt"></i>
                                    </button>
                                </li>
                                <li
                                    (click)="open(null, true)"
                                    [class.active]="!parentItem"
                                    [class.curpoint]="parentItem"
                                    aria-current="page"
                                    class="breadcrumb-item">
                                    Home
                                </li>
                                @for (crumb of breadcrumb; track crumb) {
                                    <li
                                        (click)="open(crumb)"
                                        [class.active]="crumb === parentItem"
                                        [class.curpoint]="crumb !== parentItem"
                                        aria-current="page"
                                        class="breadcrumb-item">
                                        {{ crumb.name }}
                                    </li>
                                }
                                <li class="d-flex">
                                    <button (click)="reload()" mat-button>
                                        <i [class.fa-spin]="!loaded" class="fas fa-sync-alt"></i> Herladen
                                    </button>
                                    @if (Functionalities.CustomerProjectsManage | hasFunctionality) {
                                        <button
                                            (click)="addNewItem($event, parentItem, true)"
                                            color="primary"
                                            mat-button>
                                            <i class="fas fa-folder-plus"></i> Map<span class="hidden-sm-down">
                                                toevoegen
                                            </span>
                                        </button>
                                        <button (click)="addNewItem($event, parentItem)" color="primary" mat-button>
                                            <i class="fas fa-upload"></i> Bestand<span class="hidden-sm-down">
                                                uploaden
                                            </span>
                                        </button>
                                        @if (isNativePlatform) {
                                            <button (click)="camera()" mat-button>
                                                <i class="fas fa-camera"></i>
                                                Foto
                                                <span class="hidden-sm-down"> toevoegen</span>
                                            </button>
                                        }
                                    }
                                </li>
                            </ol>
                        </nav>
                        <div
                            (contextmenu)="contextMenuItem($event, contextMenu)"
                            (press)="contextMenuItem($event, contextMenu)"
                            class="folders">
                            @for (document of viewingFolder; track document) {
                                <div
                                    (click)="select($event, document)"
                                    (contextmenu)="select($event, document)"
                                    (dblclick)="open()"
                                    (press)="select($event, document)"
                                    [class.selected]="selectedFolders.has(document)"
                                    class="item">
                                    <div class="content">
                                        @if (!document.file) {
                                            <i class="fas fa-folder-open fa-3x"></i>
                                        } @else if (extHasThumb.has(document.ext)) {
                                            <div
                                                style.background-image="url('{{
                                                    environment.apiEndpoint
                                                }}documents/thumb/{{ document.id }}?access_token={{
                                                    LocalStorage.getUserToken()
                                                }}')"
                                                class="thumb"></div>
                                        } @else {
                                            <i
                                                class="far fa-3x {{
                                                    icons[document.ext] ? icons[document.ext] : 'fa-file'
                                                }}">
                                            </i>
                                        }
                                        <div class="title">
                                            {{ document.name }}
                                        </div>
                                    </div>
                                </div>
                            }
                            <div
                                #contextMenu
                                [class.show]="showContextMenu && selectedFolders.size > 0"
                                class="context-menu">
                                @if (selectedFolders.size === 1) {
                                    <div (click)="open()"><i class="fas fa-file"></i> Open</div>
                                }
                                @if (selectedFolders.size === 1 && selectedFolders.values().next().value.file) {
                                    <div (click)="download()">
                                        <i class="fas fa-download"></i>
                                        Download
                                    </div>
                                }
                                @if (
                                    selectedFolders.size === 1 &&
                                    (Functionalities.CustomerProjectsManage | hasFunctionality)
                                ) {
                                    <div (click)="renameItem($event)">
                                        <i class="fas fa-pencil-alt"></i>
                                        Hernoemen
                                    </div>
                                }
                                @if (Functionalities.CustomerProjectsManage | hasFunctionality) {
                                    <div (click)="deleteItem($event)"><i class="fas fa-trash"></i> Verwijderen</div>
                                }
                            </div>
                        </div>
                        @if (viewingFolder?.length === 0) {
                            <div class="empty-folder">
                                <i class="fas fa-upload fa-4x"></i>
                                @if (parentItem) {
                                    <div class="title">Deze map is nog leeg!</div>
                                } @else {
                                    <div class="title">Dit werkgebied is nog leeg!</div>
                                }
                                <div>
                                    Voeg documenten toe door ze hierheen te slepen, of maak een map aan met de button in
                                    de balk.
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
}
